import React from 'react'
import Spacer from '../../../components/Spacer';
import Banner from '../../../components/Banner';
import Cards from './Cards';



function Instructions() {
  return (
    <>
    <Banner titleSection={'INSTRUCTIVOS'} linkName={'Inicio'} nameSection={'Instructivos'} />
    <Spacer/>
    <Cards/>
    <Spacer/>
    </>
  )
}

export default Instructions